import { createAccountKit } from "@jkast90/kast-common/account";
import { LegalLinks } from "@jkast90/kast-common/legal/react";
import { buttonClass } from "@jkast90/kast-common/ui";
import { useLocation } from "react-router-dom";
import { themeStore } from "../theme";
import { adminMode, session, signIn, signOut } from "./auth/session";
import { getDeploymentConfig } from "./deployment-config";

// The account pieces bound to the session (kast-common's account kit): the
// header's far end, the account page, the bug report page and the settings
// dialog. The profile button leads to the Account page, where Sign out and
// Settings live.
export const { AccountControls, AccountPage, BugReportPage, AppSettings, useAdmin } = createAccountKit({
  session,
  signIn,
  signOut: () => signOut(),
  themeStore,
  admin: adminMode,
  apiUrl: () => getDeploymentConfig().apiUrl,
  // Reports go to the kast-dev admin inbox, not salvagers-api; the crash screen sends its note in the route's state.
  useLocationState: () => useLocation().state,
  bugReport: {
    app: "salvagersgame",
    classNames: {
      button: buttonClass(),
      primaryButton: buttonClass({ variant: "primary" }),
      hint: "kui-muted kui-small",
      logButton: buttonClass({ size: "sm" }),
      logPrimaryButton: buttonClass({ variant: "primary", size: "sm" }),
    },
  },
  settings: {
    adminDescription: "Shows the Admin page and the diagnostic logs. Off, you see the site as a player does.",
    legal: <LegalLinks newTab={false} />,
  },
});
